<template>
  <div class="enterprise-container">
    <SearchBar />

    <el-table
      v-loading="listLoading"
      :data="tableData"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" width="50" label="编号">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.author }}</span>
          <el-checkbox-group
            v-model="checkList"
            @change="onCheck"
            :label="scope.row"
          >
            <!-- 加个空格不显示文字 -->
            <el-checkbox :label="scope.row">&nbsp;</el-checkbox>
          </el-checkbox-group>
        </template>
      </el-table-column>

      <el-table-column label="部门名称" align="center">
        <template slot-scope="scope">
          {{ scope.row.author }}
        </template>
      </el-table-column>
      <el-table-column label="部门编号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.author }}</span>
        </template>
      </el-table-column>
      <el-table-column label="部门简称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.author }}</span>
        </template>
      </el-table-column>
      <el-table-column label="部门性质" align="center">
        <template slot-scope="scope">
          {{ scope.row.pageviews }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="负责人" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{
            scope.row.status
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="电话号码">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.display_time }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="分机号">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.display_time }}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="备注" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{
            scope.row.status
          }}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination ref="Pagination" />
    <!-- 新增框 -->
    <addDeparyment ref="addDeparyment"></addDeparyment>
    <!-- 编辑框 -->
    <editDeparyment ref="editDeparyment"></editDeparyment>
  </div>
</template>

<script>
import SearchBar from './searchBar';
import Pagination from '@/components/Pagination';
const editDeparyment = () => import('./editDeparyment');
const addDeparyment = () => import('./addDeparyment');

export default {
  name: 'DeparymentAppMain',
  // 注册组件
  components: {
    addDeparyment,
    editDeparyment,
    SearchBar,
    Pagination,
  },
  // 生命周期钩子
  created() {
    // 初始数据获取
    this.listLoading = true;
    this.getList();
  },
  data() {
    return {
      path: '',
      tableData: [],
      checkList: [], // 选中的数列
      listLoading: false,
    };
  },
  methods: {
    // 抽取 获取企业列表的方法
    getList() {
      this.listLoading = false;
    },

    onCheck() {
      window.console.log('选中');
    },
  },
};
</script>

<style lang="less">
/* 
  container 容器
 */
.enterprise-container {
  .small {
    width: 100px;
  }
  .normal {
    width: 150px;
  }
  .body-card {
    margin-top: 20px;
  }
  .my-pagination {
    margin-top: 30px;
    text-align: center;
  }
  span.red {
    color: #ff4949;
  }
}
</style>
